// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__70wVr","icon":"Quote_icon__9mk3s"};